
// IMPORTANT: This file is auto generated! Do not manually edit or checkin!
// tslint:disable
export const GIT_INFO = {
  "dirty": false,
  "raw": "8ee08f4",
  "hash": "8ee08f4",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "8ee08f4",
  "semverString": null
};
